import { cn } from "../../../utils/css";

export type Sentiment = "positive" | "negative";

export const SentimentIcon = ({
  sentiment,
  icon,
}: {
  sentiment: Sentiment;
  icon: React.ReactNode;
}) => {
  return (
    <div
      className={cn(
        "tw-p-2 tw-text-yellow-500 tw-rounded-full tw-border",
        sentiment === "negative"
          ? "tw-border-amber-200  tw-border-2 tw-outline tw-outline-amber-100 tw-bg-amber-50"
          : "tw-border-green-200 tw-border-2 tw-outline tw-outline-green-100 tw-bg-green-50",
      )}
    >
      {icon}
    </div>
  );
};
